<template>
  <tr
    :class="classes"
    data-sb-regression="sb-table-row"
    scope="row"
  >
    <SbTableCell
      v-if="isMultiselectable || isAllMultiselectable"
      class="sb-table-cell__select"
    >
      <SbCheckbox
        v-model:checked="selectedRows"
        :disabled="disabled"
        :value="row"
        class="sb-table__select"
      />
    </SbTableCell>
    <SbTableCell
      v-if="isSingleSelectable"
      class="sb-table-cell__select"
    >
      <SbRadioButton
        v-model="selectedRow"
        :disabled="disabled"
        :value="row"
        class="sb-table__select"
      />
    </SbTableCell>
    <!--
      @slot slot to show table row
    -->
    <slot />
  </tr>
</template>
<script>
import SbCheckbox from '@src/components/Checkbox/SbCheckbox.vue';
import SbRadioButton from '@src/components/RadioButton/SbRadioButton.vue';
import _findIndex from 'lodash/findIndex';
import _isEqual from 'lodash/isEqual';
import SelectableMixin from '@src/components/Table/utils/selectableMixin';
import SbTableCell from '@src/components/Table/components/SbTableCell.vue';

export default {
  name: 'SbTableRow',
  components: {
    SbTableCell,
    SbCheckbox,
    SbRadioButton,
  },
  mixins: [SelectableMixin],
  inject: ['sbTableRow', 'sbSelectableTable'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    variation: {
      type: String,
      default: 'default',
      validator: (value) => value.match(/(default|edited)/),
    },
  },
  computed: {
    classes() {
      const classes = ['sb-table-row'];
      classes.push(`sb-table-row--${this.variation}`);
      if (this.isSelected) classes.push('sb-table-row--selected');
      if (this.disabled) classes.push('sb-table-row--disabled');
      return classes.join(' ');
    },
    row() {
      return this.sbTableRow.row;
    },
    selectedRow: {
      get() {
        return this.sbSelectableTable.selectedRow;
      },
      set(n) {
        if (_isEqual(this.sbSelectableTable.selectedRow, n)) {
          return;
        }
        this.sbSelectableTable.selectedRow = n;
      },
    },
    selectedRows: {
      get() {
        return this.sbSelectableTable.selectedRows;
      },
      set(n) {
        if (_isEqual(this.sbSelectableTable.selectedRows, n)) {
          return;
        }
        this.sbSelectableTable.selectedRows = n;
      },
    },
    isSelected() {
      if (this.isSingleSelectable) {
        return this.selectedRow === this.row;
      }
      return this.isInSelected(this.row);
    },
  },
  watch: {
    disabled(n) {
      this.resolveSelectable(n);
      this.resolveSelected(n);
      this.resolveSelectedSingle(n);
    },
  },
  mounted() {
    this.resolveSelectable(this.disabled);
  },
  methods: {
    selectableIndex(row) {
      return _findIndex(this.sbSelectableTable.selectableRows, row);
    },
    isInSelectable(row) {
      return this.selectableIndex(row) > -1;
    },
    selectedIndex(row) {
      return _findIndex(this.sbSelectableTable.selectedRows, row);
    },
    isInSelected(row) {
      return this.selectedIndex(row) > -1;
    },
    resolveSelectable(n) {
      if (!n && !this.isInSelectable(this.row)) {
        this.sbSelectableTable.selectableRows.push(this.row);
      } else if (n && this.isInSelectable(this.row)) {
        this.removeFrom(this.sbSelectableTable.selectableRows, this.row, this.selectableIndex);
      }
    },
    resolveSelected(n) {
      if (n && this.isInSelected(this.row)) {
        this.removeFrom(this.sbSelectableTable.selectedRows, this.row, this.selectedIndex);
      }
    },
    resolveSelectedSingle(n) {
      if (n && _isEqual(this.sbSelectableTable.selectedRow, this.row)) {
        this.sbSelectableTable.selectedRow = null;
      }
    },
    removeFrom(list, item, indexFunc) {
      list.splice(indexFunc(item), 1);
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Table/style/sb-table-row.scss'
</style>
